<template>
  <div class="moneyincategory" >
    <el-divider content-position="left">考核配置管理</el-divider>
    <div style="display: flex">
      <el-select
        v-model="searchArr.checkin_id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入考核项目"
        size="mini"
        clearable
        :remote-method="searchRemoteCheckIn"
        :loading="searchLoading"
        @change="handleSearchCheckInSetting"
      >
        <el-option
          v-for="searchCheckItem in searchCheckSetting"
          :key="searchCheckItem.id"
          :label="searchCheckItem.check_name"
          :value="searchCheckItem.id"
        >
        </el-option>
      </el-select>
      <div style="text-align: right; flex: 1">
        <el-button type="primary" size="small" @click="checkIn"
          >录入</el-button
        >
        <el-button type="primary" size="small" @click.native="$router.push('setting_panel')">返回上一级</el-button>
      </div>
    </div>
    
    
    <el-drawer
      title="录入"
      :visible.sync="checkIndrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="checkInForm"
          ref="checkInForm"
          label-width="100px"
        >
          <el-form-item label="考核名称">
            <el-input v-model="checkInForm.check_name" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="订单类型">
            <el-select v-model="checkInForm.order_type" multiple filterable clearable placeholder="请选择" size="mini">
              <el-option v-for="reg in orderRegTypes" :key="reg.order_reg_id" :label="reg.order_reg_name"
                :value="reg.order_reg_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否续费目标">
            <el-radio-group v-model="checkInForm.is_renewal" size="mini">
              <el-radio-button label="0">否</el-radio-button>
              <el-radio-button label="1">是</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="考核单位">
            <el-input v-model="checkInForm.check_unit" size="mini" placeholder="例：个，元"></el-input>
          </el-form-item>
          <el-form-item label="目标值">
            <el-input v-model="checkInForm.check_goal" type="number" size="mini" placeholder="例：5"></el-input>
          </el-form-item>
          <el-form-item label="是否考核">
            <el-radio-group v-model="checkInForm.is_checkin" size="mini">
              <el-radio-button label="0">否</el-radio-button>
              <el-radio-button label="1">是</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="考核周期">
            <el-radio-group v-model="checkInForm.check_circle" size="mini">
              <el-radio-button label="1">日</el-radio-button>
              <el-radio-button label="2">周</el-radio-button>
              <el-radio-button label="3">月</el-radio-button>
              <el-radio-button label="4">年</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="考核角色">
            <el-tag
              v-for="tag in dynamicTags"
              :key="tag.id"
              closable
              :disable-transitions="false"
              @close="handleClosed(tag.id)"
              style="margin-left: .1rem;"
            >{{ tag.role_name }}</el-tag>
            <el-select
              v-if="inputVisible"
              ref="saveTagInput"
              class="input-new-tag"
              v-model="checkInForm.check_roles"
              multiple
              placeholder="请选择人员"
              style="width: 100%"
              size="mini"
              filterable
              @focus="onBlur"
              @change="setSelectStatus"
            >
            <el-option v-for="role in roles" :key="role.id" :label="role.role_name"
                :value="role.id"></el-option>
            </el-select>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">+新增</el-button>
          </el-form-item>

          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="submitForm"
              >添加</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>


    <el-drawer
      title="修改"
      :visible.sync="checkInEditDrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="editcheckInForm"
          ref="editcheckInForm"
          label-width="100px"
        >
          <el-form-item label="考核名称" prop="">
            <el-input
              v-model="editcheckInForm.check_name"
              size="mini"
            ></el-input>
          </el-form-item>

          <el-form-item label="订单类型">
            <el-select v-model="editcheckInForm.order_type" 
            multiple filterable clearable
             placeholder="请选择" size="mini">
              <el-option v-for="reg in orderRegTypes" :key="reg.order_reg_id" :label="reg.order_reg_name"
                :value="reg.order_reg_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否续费目标">
            <el-radio-group v-model="editcheckInForm.is_renewal" size="mini">
              <el-radio-button label="0">否</el-radio-button>
              <el-radio-button label="1">是</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="考核单位">
            <el-input v-model="editcheckInForm.check_unit" size="mini" placeholder="例：个，元"></el-input>
          </el-form-item>
          <el-form-item label="目标值">
            <el-input v-model="editcheckInForm.check_goal" type="number" size="mini" placeholder="例：5"></el-input>
          </el-form-item>
          <el-form-item label="是否考核">
            <el-radio-group v-model="editcheckInForm.is_checkin" size="mini">
              <el-radio-button label="0">否</el-radio-button>
              <el-radio-button label="1">是</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否必填">
            <el-radio-group v-model="editcheckInForm.is_required" size="mini">
              <el-radio-button label="0">否</el-radio-button>
              <el-radio-button label="1">是</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="考核周期">
            <el-radio-group v-model="editcheckInForm.check_circle" size="mini">
              <el-radio-button label="1">日</el-radio-button>
              <el-radio-button label="2">周</el-radio-button>
              <el-radio-button label="3">月</el-radio-button>
              <el-radio-button label="4">年</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="考核角色">
            <el-tag
              v-for="tag in dynamicTagss"
              :key="tag.id"
              closable
              :disable-transitions="false"
              @close="handleCloses(tag.id)"
              style="margin-left: .1rem;"
            >{{ tag.role_name }}</el-tag>
            <el-select
              v-if="inputVisibles"
              ref="saveTagInputs"
              class="input-new-tag"
              v-model="editcheckInForm.roles"
              multiple
              placeholder="请选择人员"
              style="width: 100%"
              size="mini"
              filterable
              @focus="onBlurs"
              @change="setSelectStatuss"
            >
            <el-option v-for="role in roles" :key="role.id" :label="role.role_name"
                :value="role.id"></el-option>
            </el-select>
            <el-button v-else class="button-new-tag" size="small" @click="showInputs">+新增</el-button>
          </el-form-item>


          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="editSubmitForm"
              >修改</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>


    <el-table
      :data="checkInSetting"
      style="width: 100%; margin-top: 10px"
      border
      size="mini"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
      height="470"
    >
      <el-table-column prop="check_name" label="考核名称" width="120" fixed></el-table-column>
      <el-table-column label="订单类型" width="150">
        <template slot-scope="scope">
          <p v-html="scope.row.order_type_name"></p>
        </template>
      </el-table-column>
      <el-table-column label="是否续费目标" width="auto">
        <template slot-scope="scope">
          <span v-if="scope.row.is_renewal === 1">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column prop="check_unit" label="考核单位" width="80"></el-table-column>
      <el-table-column prop="check_goal" label="目标值" width="90"></el-table-column>
      <el-table-column label="是否考核" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.is_checkin === 1">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column label="是否必填" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.is_required === 1">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column label="考核周期" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.check_circle === 1">日</span>
          <span v-else-if="scope.row.check_circle === 2">周</span>
          <span v-else-if="scope.row.check_circle === 3">月</span>
          <span v-else-if="scope.row.check_circle === 4">年</span>
        </template>
      </el-table-column>
      <el-table-column label="考核角色" width="120">
        <template slot-scope="scope">
          <p v-html="scope.row.role_name"></p>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <el-button
              @click.native.prevent="editRow(scope.$index, scope.row)"
              type="primary"
              size="mini"
              icon="el-icon-edit"
              circle
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>


    <div class="block" style="margin-top: 10px; text-align: right">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 15, 30, 50, 100]"
        :page-size="checkInPerPage"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckSetting',
  data () {
    return {

      searchArr: {
        checkin_id: ''
      },
      npage: 1,
      checkInPerPage: 10,
      total: null,
      checkInSetting: [],
      direction: 'rtl',
      searcher: null,
      searchLoading: false,
      searchCheckSetting: [],
      checkIndrawer: false,
      checkInEditDrawer: false,
      checkInForm: {
        check_name: '',
        order_type: [],
        check_unit: '',
        check_goal: 1,
        is_checkin: '1',
        is_required: '1',
        check_circle: '1',
        check_roles: [],
        is_renewal: '0'
      },
      editcheckInForm: {
        id: null,
        order_type: [],
        check_name: '',
        check_unit: '',
        check_goal: 1,
        is_checkin: '1',
        is_required: '1',
        check_circle: '1',
        roles: [],
        is_renewal: '0'
      },
      orderRegTypes: [],
      roles: [],
      inputVisible: false,
      inputVisibles: false
    }
  },
  mounted () {
    this.loadTable()
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    },
    dynamicTags () {
      let arr = []
      this.roles.forEach((item) => {
        this.checkInForm.check_roles.forEach((i) => {
          if (item.id === i)
            arr.push({
              id: i,
              role_name: item.role_name,
            })
        })
      })
      return arr
    },
    dynamicTagss () {
      let arr = []
      this.roles.forEach((item) => {
        this.editcheckInForm.roles.forEach((i) => {
          if (item.id === i)
            arr.push({
              id: i,
              role_name: item.role_name,
            })
        })
      })
      return arr
    },
  },
  methods: {
    loadTable () {
      this.$axios
        .get('api/admin/check/get_check_setting', {
          params: {
            page: this.npage,
            perpage: this.checkInPerPage,
            searchItem: this.searcher
          }
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.orderRegTypes = data.orderRegs
            this.checkInSetting = data.data.data
            this.roles = data.roles
            this.total = data.data.total
          }
        })
        .catch()
    },
    handleClosed (id) {
      this.checkInForm.check_roles.forEach((item, index) => {
        if (item === id) this.checkInForm.check_roles.splice(index, 1)
      })
    },
    setSelectStatus () {
      this.inputVisible = false
    },
    onBlur() {
      this.$refs.saveTagInput.$refs.input.blur = () => {
        this.inputVisible = false
      }
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleCloses (id) {
      this.editcheckInForm.roles.forEach((item, index) => {
        if (item === id) this.editcheckInForm.roles.splice(index, 1)
      })
    },
    setSelectStatuss () {
      this.inputVisibles = false
    },
    onBlurs() {
      this.$refs.saveTagInputs.$refs.input.blur = () => {
        this.inputVisibles = false
      }
    },
    showInputs () {
      this.inputVisibles = true
      this.$nextTick((_) => {
        this.$refs.saveTagInputs.$refs.input.focus()
      })
    },
    handleCurrentChange (val) {
      this.npage = val
      this.loadTable()
    },
    handleSizeChange (val) {
      this.checkInPerPage = val
      this.loadTable()
    },
    checkIn () {
      this.checkIndrawer = true
    },
    submitForm () {
      if (!this.checkInForm.check_name) {
        this.$message.error('请填写考核名称!')
        return false
      }
      if (this.checkInForm.check_roles.length <= 0) {
        this.$message.error('请选择考核角色!')
        return false
      }
      // console.log(this.checkInForm);return;
      this.$axios
        .post('api/admin/check/store', {
          check_data: this.checkInForm
        })
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.checkIndrawer = false
            this.loadTable()
            this.resetForm()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    editSubmitForm () {
      this.$axios
        .post('api/admin/check/edit_store', {
          check_setting: this.editcheckInForm
        })
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.checkInEditDrawer = false
            this.loadTable()
            this.resetForm()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    editRow (index, row) {
      this.editcheckInForm.id = row.id
      this.editcheckInForm.check_name = row.check_name
      this.editcheckInForm.order_type = row.order_type.split(",").map(Number)
      this.editcheckInForm.check_unit = row.check_unit
      this.editcheckInForm.check_goal = row.check_goal
      this.editcheckInForm.is_checkin = row.is_checkin
      this.editcheckInForm.is_required = row.is_required
      this.editcheckInForm.check_circle = row.check_circle
      this.editcheckInForm.is_renewal = row.is_renewal
      this.editcheckInForm.roles = row.check_roles.split(",").map(Number)
      this.checkInEditDrawer = true
    },
    searchRemoteCheckIn (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItem(query)
        }, 200)
      } else {
        this.searchCheckSetting = []
      }
    },
    searchItem (query) {
      this.$axios
        .get('api/admin/check/check_item_search', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.searchCheckSetting = data.data
          }
        })
        .catch()
    },
    handleSearchCheckInSetting (query) {
      this.searcher = query
      setTimeout(() => {
        this.loadTable()
      })
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.resetForm()
          done()
        })
        .catch(_ => {})
    },
    resetForm () {
      // 添加
      this.checkInForm.check_name = ''
      this.checkInForm.order_type = []
      this.checkInForm.check_unit = ''
      this.checkInForm.check_goal = 1
      this.checkInForm.is_checkin = '1'
      this.checkInForm.is_required = '1'
      this.checkInForm.check_circle = '1'
      this.checkInForm.check_roles = []
      this.checkInForm.is_renewal = '0'
      // 编辑
      this.editcheckInForm.id = null
      this.editcheckInForm.check_name = ''
      this.editcheckInForm.order_type = []
      this.editcheckInForm.check_unit = ''
      this.editcheckInForm.check_goal = 1
      this.editcheckInForm.is_checkin = '1'
      this.editcheckInForm.is_required = '1'
      this.editcheckInForm.check_circle = '1'
      this.editcheckInForm.roles = [],
      this.editcheckInForm.is_renewal = '0'
    },
  }
}
</script>

<style  scoped>
.moneyincategory {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/setting_panel/CheckSetting.vue